__turbopack_context__.v({
  "edit": "edit-hoc-module__8jXJRa__edit",
  "inline": "edit-hoc-module__8jXJRa__inline",
  "wrapper": "edit-hoc-module__8jXJRa__wrapper",
});
